export default __webpack_public_path__ + "static/media/banner-2.7ed6ac3c.jpg";